module.exports = __webpack_public_path__ + "static/img/teamPic.8ce8bb5.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/teamPic.png
// module id = PeRB
// module chunks = 2